import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

export const NOMINAL = {
  payload: {
    description:
      'Represents data that are technically true but not effectively true. For example, if a room is technically assigned to a particular department, but that department is not actually using the room',
    name: 'Nominal',
    partialId: PartialId.Standard.create('nominal'),
  },
  type: core.quiver.Resource.Type.DmsPurpose,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsPurpose>
